// Виджет для строки меню, прилипающей к верху при прокрутке.
// Элемент должен иметь `position: sticky; top: 0` в стилях, а класс
// `is-stuck` навешивается на него в тот момент, когда он коснулся
// верхнего края окна. По этому классу стили плавно убирают поля и
// скругления и компенсируют их внутренним отступом.
export default function stickyHeader(element) {
    // IntersectionObserver с отрицательным верхним rootMargin в 1px:
    // пока элемент полностью виден (не прилип) — ratio === 1, как только
    // он прилипает к верху и обрезается этим 1px — ratio < 1.
    const observer = new IntersectionObserver(
        ([entry]) => {
            element.classList.toggle("is-stuck", entry.intersectionRatio < 1);
        },
        {
            threshold: [1],
            rootMargin: "-1px 0px 0px 0px",
        }
    );

    observer.observe(element);
}
